// extracted by mini-css-extract-plugin
export var wordContainer = "_r6-0";